export const convertOneLine = (str: string) => {
  return str
    .replace(/\r?\n/g, "")
    .replace(/\s+/g, " ")
    .replace(/^\s+|\s+$/g, "");
};
